<div class="confirm-modal ig-modal search-place-result-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div class="title">SEARCH RESULT</div>

    <div class="info-body">
        <div class="info-text" *ngIf="data.places.length">Please select the Google places you want to add</div>
        <div class="no-places-found" *ngIf="!data.places || !data.places.length">No such places found.</div>
        <ig-list *ngIf="data.places.length">
            <div header>
                <ig-list-column-header>
                    <div style="max-width:1px"></div>
                    <div>Image</div>
                    <div>Name</div>
                    <div>Address</div>
                    <div>Types</div>
                    <div>Rating</div>
                    <div>Map</div>
                </ig-list-column-header>
            </div>
            <div body>
                <ig-list-item *ngFor="let place of data.places">
                    <div content>
                        <div style="max-width:1px">
                            <mat-checkbox style="vertical-align: middle" [(ngModel)]="place.checked"
                                (change)="selectedChanged(place)" [disabled]="place.existed"></mat-checkbox>
                        </div>
                        <div style="position:relative;display: flex;align-items: center;justify-content: center;">
                            <img *ngIf="place.photos" class="place-image"
                                [src]="imageService.imageSourceUrl(place.photos?place.photos[0].cover:null)" />
                            <div *ngIf="!place.photos">
                                <div>(no image)</div>
                                <ig-image-selector [isShowUploadIcon]="false"
                                    (onImageChanged)="updateImage($event, place)" [isSmallIcon]="true" [isSimple]="true"
                                    [command]="command" [selectedImageData]="selectedImageData"></ig-image-selector>
                            </div>
                            <div *ngIf="place.business_status?.includes('CLOSED')" matTooltip="This place is closed"
                                style="position:absolute;padding: 4px;color:white;background:rgb(233, 58, 87);text-align: center;">
                                {{place.business_status.replace('_', ' ')}}
                            </div>
                        </div>
                        <div [class.not-allowed]="notAllowed(place)"
                            [matTooltip]="notAllowed(place)?'This place doesn\'t have any category that is allowed to show, please consider update your custom place category settings':''">
                            {{place.name}}
                            <div *ngIf="place.existed" class="exist" [matTooltip]="place.statusMessage">
                                This place has been added.
                            </div>
                        </div>
                        <div>
                            {{place.formatted_address}}
                        </div>
                        <div>
                            <mat-chip-list #chipList aria-label="Type selection">
                                <mat-chip *ngFor="let type of place.types" [selectable]="true"
                                    matTooltip="{{isTypeBlocked(type)?'this type is blocked, consider to remove it from this list, otherwise this place will not be shown':''}}"
                                    [removable]="true" (removed)="removeType(place, type)"
                                    [class.google-blocked-categories]="isTypeBlocked(type)">
                                    {{type}}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                            </mat-chip-list>
                            <span *ngIf="!place.types.length">(no types selected)</span>
                            <div *ngIf="isUseDefaultCustomPlaceCategory" (click)="showEditCategoryModal(place)"
                                class="edit-category-btn">Edit Category</div>
                        </div>
                        <div>{{place.rating}}</div>
                        <div>
                            <agm-map [zoom]="14" [latitude]="place.geometry.location.lat"
                                [longitude]="place.geometry.location.lng">
                                <agm-marker [latitude]="place.geometry.location.lat"
                                    [longitude]="place.geometry.location.lng">
                                </agm-marker>
                            </agm-map>
                        </div>
                    </div>
                </ig-list-item>
            </div>
        </ig-list>
    </div>
    <div class="action-btns">
        <div>
            <span>Save as</span>
            <mat-radio-group class="radio-group" [(ngModel)]="isApproved">
                <mat-radio-button [value]="true">
                    APPROVED
                </mat-radio-button>
                <mat-radio-button [value]="false">
                    UNAPPROVED
                </mat-radio-button>
            </mat-radio-group>
        </div>
        <ig-button *ngIf="data.places.length" class="btn-primary" color="primary" size="md" [isAsync]="true"
            [matTooltip]="isAllPlaceCategoriesNotMatched()?'Please edit category before saving':''"
            [disabled]="isAllPlaceCategoriesNotMatched()" (trigger)="confirm($event)">
            Save
        </ig-button>
        <div class="cancel-btn" (click)="close()">
            Cancel
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.account/content.management/search.google.place/search.google.place.result.modal/search.google.place.result.modal.component.html